import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectIsOpen } from "../Selectors/NavigationMobileButton-selectors";
import { setIsOpen } from "../Actions/Navigation.action";
import { translate } from "../Services/translation";
import { useOutsideClick } from "../Hooks/useOutsideClick";

// Classes
const OVERLAY_CLASSES = ["navbar-overlay", "navbar-overlay--full"];
const NAVBAR_OPEN_CLASS = "navbar-mobile--open";
const NAVBAR_CLOSE_BUTTON_VISIBLE_CLASS =
  "navbar-mobile__close-button--visible";

// Translations
const TRANSLATION_NAVBAR_TITLE = "navbar.title";
const TRANSLATION_NAVBAR_BACK = "navbar.back";
const TRANSLATION_SHOW_MORE_LINK = "megamenu.showmorelink";

const NavigationMobile = (props) => {
  let menuRef = React.createRef();
  let closeButtonRef = React.createRef();

  const dispatch = useDispatch();

  const { links } = props;

  const isOpen = useSelector(selectIsOpen);
  const [currentItem, setCurrentItem] = React.useState({ links });
  const body = () => document.querySelector("body");

  const closeMenu = () => {
    dispatch(setIsOpen(false));
  };

  useOutsideClick(isOpen ? menuRef : null, () => {
    closeMenu();
  });

  const showChildLinks = (item) => {
    var tree = item;
    tree.parent = currentItem;
    setCurrentItem(tree);
  };

  const goToParentLink = () => {
    setCurrentItem(currentItem.parent);
  };

  React.useEffect(() => {
    if (!menuRef && !menuRef.current) return;

    if (isOpen) {
      menuRef.current.classList.add(NAVBAR_OPEN_CLASS);

      if (closeButtonRef && closeButtonRef.current) {
        setTimeout(() => {
          closeButtonRef.current.classList.add(
            NAVBAR_CLOSE_BUTTON_VISIBLE_CLASS
          );
        }, 300);
      }

      body().classList.add(...OVERLAY_CLASSES);
    } else {
      menuRef.current.classList.remove(NAVBAR_OPEN_CLASS);

      if (closeButtonRef && closeButtonRef.current)
        closeButtonRef.current.classList.remove(
          NAVBAR_CLOSE_BUTTON_VISIBLE_CLASS
        );

      body().classList.remove(...OVERLAY_CLASSES);
    }
  }, [isOpen]);

  return (
    <>
      <div className="navbar-mobile" ref={menuRef}>
        <div className="navbar-mobile__header">
          <div className="navbar-mobile__header-left">
            {currentItem && currentItem.parent ? (
              <div
                className="navbar-mobile__title navbar-mobile__title--back"
                onClick={goToParentLink}
              >
                <i className="fas fa-chevron-left"></i>{" "}
                {translate(TRANSLATION_NAVBAR_BACK)}
              </div>
            ) : (
              <div className="navbar-mobile__title">
                {translate(TRANSLATION_NAVBAR_TITLE)}
              </div>
            )}
          </div>
          {!currentItem ||
            (!currentItem.parent && (
              <div className="navbar-mobile__header-right">
                <div
                  dangerouslySetInnerHTML={{ __html: props.innerHtml }}
                ></div>
                <div className="profile">
                  <a href={props.profileUrl} className="profile__link--block">
                    <i className="fal fa-user"></i>
                    <span className="profile__title">{props.profileText}</span>
                  </a>
                </div>
              </div>
            ))}
        </div>
        <div className="navbar-mobile__items">
          {currentItem.links.map((link) => {
            // Hide the "show more" links in mobile
            if (
              link.name &&
              link.name.indexOf(translate(TRANSLATION_SHOW_MORE_LINK)) != -1
            )
              return;

            return (
              <div
                key={link.name + link.url}
                className={[
                  "navbar-mobile__item",
                  link.links.length > 0
                    ? "navbar-mobile__item--has-children"
                    : "",
                ].join(" ")}
              >
                <div className="navbar-mobile__item-title">
                  <a
                    href={link.url}
                    dangerouslySetInnerHTML={{
                      __html: link.name ? link.name : link.url,
                    }}
                    style={{ color: `#${link.mainMenuLinkColor}` }}
                  ></a>
                </div>
                {link.links.length > 0 && (
                  <div
                    className="navbar-mobile__item--show-children"
                    onClick={() => showChildLinks(link)}
                  >
                    <i className="fas fa-chevron-right"></i>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
      <a
        className="navbar-mobile__close-button"
        onClick={closeMenu}
        ref={closeButtonRef}
      >
        <i className="fal fa-times"></i>
      </a>
    </>
  );
};

export default NavigationMobile;
